import DateRangeFilter from './DateRangeFilter.jsx';
import FilterBar from './FilterBar.jsx';
import OriginTagsFilter from './OriginTagsFilter.jsx';

/**
 * Barra de filtros reutilizable entre módulos.
 * @param {{
 *   filters: object,
 *   showExecutive?: boolean,
 *   showProject?: boolean,
 *   showChannel?: boolean,
 *   showStatus?: boolean,
 *   showOriginTags?: boolean,
 *   originTagOptions?: Array<{id:string,label:string,isMeta?:boolean|null,group?:string}>,
 *   originTagsLoading?: boolean,
 *   executives?: Array<{id:string,label:string}>,
 *   projects?: Array<{id:string,label:string}>,
 *   channels?: Array<{id:string,label:string}>,
 *   statuses?: Array<{id:string,label:string}>,
 *   disabled?: boolean,
 *   busy?: boolean,
 *   onRefresh?: () => void,
 *   onCancel?: () => void
 * }} props
 */
export default function ModuleFilters({
  filters,
  showExecutive = true,
  showProject = true,
  showChannel = false,
  showStatus = false,
  showOriginTags = false,
  originTagOptions = [],
  originTagsLoading = false,
  executives = [],
  projects = [],
  channels = [],
  statuses = [],
  disabled = false,
  busy = false,
  onRefresh,
  onCancel
}) {
  const f = filters;
  return (
    <FilterBar label="Filtros del módulo">
      <DateRangeFilter
        id="mod-period"
        value={f.period}
        options={f.periodOptions}
        disabled={disabled}
        onChange={(v) => {
          f.setPeriod(v);
          if (v !== 'custom') {
            f.setDateFrom('');
            f.setDateTo('');
          }
        }}
      />
      {f.period === 'custom' ? (
        <>
          <label className="analytics-field">
            <span>Desde</span>
            <input
              type="date"
              value={f.dateFrom}
              disabled={disabled}
              onChange={(e) => f.setDateFrom(e.target.value)}
            />
          </label>
          <label className="analytics-field">
            <span>Hasta</span>
            <input
              type="date"
              value={f.dateTo}
              disabled={disabled}
              onChange={(e) => f.setDateTo(e.target.value)}
            />
          </label>
        </>
      ) : null}
      {showOriginTags ? (
        <OriginTagsFilter
          options={originTagOptions.length ? originTagOptions : f.originTagOptions || []}
          value={f.originTags || []}
          onChange={f.setOriginTags}
          disabled={disabled}
          loading={originTagsLoading || f.originTagsLoading}
          onSelectMetaOnly={f.selectOriginMetaOnly}
          onSelectAll={f.selectOriginAll}
          onClear={f.clearOriginTags}
        />
      ) : null}
      {showExecutive ? (
        <label className="analytics-field">
          <span>Ejecutivo</span>
          <select
            value={f.executiveId}
            disabled={disabled || !executives.length}
            onChange={(e) => f.setExecutiveId(e.target.value)}
            aria-label="Filtrar por ejecutivo"
          >
            <option value="">{executives.length ? 'Todos' : 'Sin catálogo'}</option>
            {executives.map((x) => (
              <option key={x.id} value={x.id}>
                {x.label}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      {showProject ? (
        <label className="analytics-field">
          <span>Proyecto</span>
          <select
            value={f.projectId}
            disabled={disabled || !projects.length}
            onChange={(e) => f.setProjectId(e.target.value)}
            aria-label="Filtrar por proyecto"
          >
            <option value="">{projects.length ? 'Todos' : 'Sin catálogo'}</option>
            {projects.map((x) => (
              <option key={x.id} value={x.id}>
                {x.label}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      {showChannel ? (
        <label className="analytics-field">
          <span>Canal</span>
          <select
            value={f.channel}
            disabled={disabled || !channels.length}
            onChange={(e) => f.setChannel(e.target.value)}
            aria-label="Filtrar por canal"
          >
            <option value="">{channels.length ? 'Todos' : 'Sin catálogo'}</option>
            {channels.map((x) => (
              <option key={x.id} value={x.id}>
                {x.label}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      {showStatus ? (
        <label className="analytics-field">
          <span>Estado</span>
          <select
            value={f.status}
            disabled={disabled || !statuses.length}
            onChange={(e) => f.setStatus(e.target.value)}
            aria-label="Filtrar por estado"
          >
            <option value="">{statuses.length ? 'Todos' : 'Sin catálogo'}</option>
            {statuses.map((x) => (
              <option key={x.id} value={x.id}>
                {x.label}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      {onRefresh ? (
        <button
          type="button"
          className={'analytics-btn' + (busy ? ' is-loading' : '')}
          disabled={false}
          onClick={onRefresh}
          aria-busy={busy ? 'true' : 'false'}
          title="Consultar el período elegido"
        >
          {busy ? (
            <>
              <span className="analytics-btn-spinner analytics-btn-spinner-dark" aria-hidden />
              Buscando…
            </>
          ) : (
            'Buscar'
          )}
        </button>
      ) : null}
      {busy && onCancel ? (
        <button
          type="button"
          className="analytics-btn analytics-btn-ghost"
          onClick={onCancel}
          title="Interrumpir la búsqueda en curso"
        >
          Cancelar
        </button>
      ) : null}
    </FilterBar>
  );
}
